import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getCheggTldFrom, getLangPreferenceCookie, CheggTlds } from '@chegg/utils';
var esLocales = ['es-MX', 'es-419', 'es'];
var DEFAULT_LANGUAGE_LOCALE = _defineProperty(_defineProperty({}, CheggTlds.MX, 'es-419'), CheggTlds["default"], 'en-US');
export var enTexts = {
  sendEmailText: {
    header: 'New device?',
    subHeader: "Let's double-check it's you.",
    description: "We'll send a verification code to: ",
    buttonText: 'Send code',
    footer: 'Wrong email address?',
    footerFAQ: 'Check our FAQs.',
    footerTitle: 'Code expires after 10 minutes.',
    goBack: 'Go Back'
  },
  validateCodeText: {
    header: 'Enter the code we sent to:',
    codePlaceholder: 'e.g. 123-456',
    secondDecription: 'Having trouble? ',
    requestCodeLink: 'Get a new code',
    newCodeInfo: '(You may have to check your spam folder)',
    buttonText: 'Continue',
    footer: "Make sure our email didn't go to your spam folder. You can also ",
    footerSendAgain: 'request a new one',
    footerWrongAddress: 'Need to switch emails? ',
    footerCheckFAQ: 'Contact us'
  },
  errorMessages: {
    invalid_grant: 'Invalid code. Please try again.',
    expired_token: 'This code expired. Click the link below to get a new one.',
    downstream_server_issue: "It's not you, it’s us. Please try again later.",
    unknown_mfa_error: 'Something went wrong.',
    start_over_link_text: 'please start over.',
    request_new_token: 'Request a new code',
    too_many_requests: "You've tried too many times. For your security, ",
    try_again_text: 'try again',
    later_text: ' in 5 minutes.'
  }
};
export var esTexts = {
  sendEmailText: {
    header: '¿Dispositivo nuevo?',
    subHeader: 'Verifiquemos que de verdad eres tú.',
    description: 'Enviaremos un código de verificación a: ',
    buttonText: 'Enviar código',
    footer: '¿Dirección de correo electrónico incorrecta?',
    footerFAQ: 'Consulta nuestras Preguntas frecuentes.',
    footerTitle: 'El código caduca tras 10 minutos.',
    goBack: 'Vuelve'
  },
  validateCodeText: {
    header: 'Ingresa el código que te enviamos a:',
    codePlaceholder: 'por ejemplo, 123-456',
    secondDecription: '¿Tienes inconvenientes? ',
    requestCodeLink: 'Obtén un código nuevo',
    newCodeInfo: '(Es posible que tengas que revisar tu carpeta de spam)',
    buttonText: 'Continúa',
    footer: 'Asegúrate de que nuestro correo electrónico no haya ido a tu carpeta de spam. También puedes ',
    footerSendAgain: 'solicitar uno nuevo',
    footerWrongAddress: '¿Necesitas cambiar de correo electrónico? ',
    footerCheckFAQ: 'Contáctanos'
  },
  errorMessages: {
    invalid_grant: 'Código no válido. Inténtalo de nuevo.',
    expired_token: 'Este código caducó. Escoge el siguiente enlace para obtener uno nuevo.',
    downstream_server_issue: 'No eres tú, somos nosotros. Inténtalo de nuevo más tarde.',
    unknown_mfa_error: 'Algo salió mal.',
    start_over_link_text: 'empieza de nuevo.',
    request_new_token: 'Solicita un código nuevo',
    too_many_requests: 'Lo intentaste demasiadas veces. Por tu seguridad, ',
    try_again_text: 'inténtalo de nuevo',
    later_text: ' en 5 minutos.'
  }
};
export function getTexts() {
  var _getLangPreferenceCoo;
  var tld = getCheggTldFrom(window.location.origin);
  var locale = (_getLangPreferenceCoo = getLangPreferenceCookie()) !== null && _getLangPreferenceCoo !== void 0 ? _getLangPreferenceCoo : tld ? DEFAULT_LANGUAGE_LOCALE[tld] : 'en-US';
  return esLocales.includes(locale) ? esTexts : enTexts;
}